import { createRouter, createWebHistory } from "vue-router";
import store from "@/store"; // Import the Vuex store directly
import Dashboard from "../views/Dashboard.vue";
import Tables from "@/views/Tables.vue";
import Billing from "@/views/Billing.vue";
import VirtualReality from "@/views/VirtualReality.vue";
import Profile from "../views/Profile.vue";
import Rtl from "@/views/Rtl.vue";
import SignIn from "../views/SignIn.vue";
import Communications from "../views/communications.vue";
import CommunicationLogs from "../views/communicationLogs.vue";
import SmsCredit from "../views/sms_credits.vue";

import PatientsIndex from "../views/Patients/PatientsIndex.vue";
import VisitsDashboard from "../views/visits_management/VisitsDashboard.vue";
import ReceptionList from "../views/visits_management/reception_list.vue";
import ReceptionAppointments from "../views/visits_management/reception_appointments.vue";
import FinanceIndex from "../views/Finance/FinanceIndex.vue";
import RevenueByDates from "../views/Finance/revenue_by_dates.vue";

import PendingInvoices from "../views/Finance/pending_invoices.vue";
import InsuranceClaims from "../views/Finance/insurance_claims.vue";
import Expenses from "../views/Finance/expenses_by_dates.vue";
import InvoiceBreakdown from "../views/Finance/invoice_breakdown.vue";
import InventoryAndSales from "../views/Finance/inventory_and_sales.vue";
import Accounts from "../views/Finance/accounts.vue";
import POProcessing from "../views/Finance/po_processing.vue";
import FinanceBook from "../views/Finance/finance_book.vue";
import FinanceAccountDetail from "../views/Finance/finance_account_detail.vue";
import AccountStatement from "../views/Finance/account_statements.vue";

import PayableAccountDetail from "../views/Finance/payable_account_detail.vue";
import InventoryAccountDetail from "../views/Finance/inventory_account_detail.vue";
import ExpenseAccountDetail from "../views/Finance/expense_account_detail.vue";

import Inventory from "../views/Inventory/InventoryIndex.vue";
import ConsumablesSet from "../views/Inventory/consumables_set.vue";
import ChargeConsumablesSet from "../views/Inventory/charge_consumables_set.vue";
import ItemCategories from "../views/Inventory/ItemCategories.vue";
import PurchaseOrdersIndex from "../views/Inventory/purchase_orders_index.vue";
import PurchaseOrdersDetail from "../views/Inventory/purchase_order_detail.vue";
import PurchaseOrdersDeliveredDetail from "../views/Inventory/po_delivered.vue";
import PurchaseOrdersCreate from "../views/Inventory/purchase_orders_create.vue";
import ItemClasses from "../views/Inventory/ItemClasses.vue";
import ItemStores from "../views/Inventory/ItemStores.vue";
import ItemSuppliers from "../views/Inventory/ItemSuppliers.vue";
import ItemRegister from "../views/Inventory/ItemRegister.vue";
import StockTakingIndex from "../views/Inventory/stock_taking_index.vue";
import StockTakingSession from "../views/Inventory/stock_taking_session.vue";
import StockTakingReport from "../views/Inventory/stock_taking_report.vue";

import ItemStock from "../views/Inventory/ItemStock.vue";
import Expiring from "../views/Inventory/expiring.vue";
import OutOfStock from "../views/Inventory/outOfStock.vue";
import ItemStockDetails from "../views/Inventory/ItemStockDetails.vue";
import InternalOrders from "../views/Inventory/InternalOrders.vue";
import Triage from "@/views/visits_management/triage.vue";
import Consultation from "../views/visits_management/consultation.vue";
import ConsultationService from "../views/visits_management/consultation_service.vue";
import ConsultationAtLab from "../views/visits_management/consultation_at_lab.vue";
import ConsultationAtRadiology from "../views/visits_management/consultation_at_radiology.vue";
import ConsultationAtNursing from "../views/visits_management/consultation_at_nursing.vue";
import ConsultationAtPharmacy from "../views/visits_management/consultation_at_pharmacy.vue";
import ConsultationAtInpatient from "../views/visits_management/consultation_at_inpatient.vue";
import ConsultationAtDiagnosis from "../views/visits_management/consultation_at_diagnosis.vue";

import DialysisQueue from "../views/visits_management/dialysis/disalysis_queue.vue";

import Lab from "../views/visits_management/lab/lab_index.vue";
import LabDetails from "../views/visits_management/lab/lab_details.vue";
import Radiology from "../views/visits_management/radiology/radiology_index.vue";
import NursingRoom from "@/views/visits_management/nursing/nursung_index.vue";
import Pharmacy from "../views/visits_management/pharmacy/pharmacy_index.vue";
import Cashier from "../views/visits_management/cashier/cashier_index.vue";
import CashierWalkin from "../views/visits_management/cashier/cashier_walkin_index.vue";
import Receipts from "../views/visits_management/receipts/receipts_index.vue";
import Invoices from "../views/visits_management/invoices/invoices_index.vue";
import OffCourseInvoices from "../views/visits_management/invoices/off_course_invoices.vue";
import OffCourseInvoiceCreate from "../views/visits_management/invoices/off_course_invoice_create.vue";
import OffCourseInvoiceEdit from "../views/visits_management/invoices/off_course_invoice_edit.vue";
import OffCourseInvoiceView from "../views/visits_management/invoices/off_course_invoice_view.vue";
import InvoiceDetail from "../views/visits_management/invoices/invoices_detail.vue";
import InsuranceInvoiceDetail from "../views/visits_management/invoices/insurance_invoices_detail.vue";

import OTCPharmacy from "../views/visits_management/pharmacy/otc_pharmacy_index.vue";
import VisitSummary from "../views/visits_management/visit_summary/visit_summary_index.vue";
import Settings from "../views/settings/settings_index.vue";
// import ServiceSetting from "../views/settings/services/service_index.vue";
import LabSetting from "../views/settings/services/lab_setting.vue";
import WardSettings from "../views/settings/bed/ward_setting.vue";
import BedSettings from "../views/settings/bed/bed_setting.vue";
import BedClass from "../views/settings/bed/bed_classes.vue";
import RadiologySetting from "../views/settings/services/radio_setting.vue";
import NursingSetting from "../views/settings/services/nurse_setting.vue";
import InpatientSettings from "../views/settings/services/inpatient_setting.vue";
import OrgSettings from "../views/settings/organization/organization_info.vue";
import InsuranceSettings from "../views/settings/insurance/insurance_setting_index.vue";
import SchemeSettings from "../views/settings/insurance/scheme_setting_index.vue";
import MessagingSettings from "../views/settings/messaging/messaging_setting.vue";
import DialysisSettings from "../views/settings/dialysis/general_dialysis_setting.vue";

import OtherSettings from "../views/settings/services/other_setting.vue";
import AdditionalSettings from "../views/settings/additional_settings/CompanySettings.vue";

import SpecialClinicsMenu from "../views/special_clinics/clinics_index.vue";
import SystemUsers from "../views/system_users/users_index.vue";
import Dialysis from "../views/special_clinics/dialysis/dialysis_index.vue";
import DialysisProcedure from "../views/special_clinics/dialysis/dialysis_procedure.vue";
import InpatientIndex from "../views/inpatient/inpatient_index.vue";
import InpatientTimeline from "../views/inpatient/inpatient_timeline.vue";
import AwaitingBeds from "../views/inpatient/awaiting_beds_index.vue";

import MchIndex from "../views/special_clinics/mch/mch_index.vue";
import AncVisits from "../views/special_clinics/mch/anc_visits.vue";
import AncTreatment from "../views/special_clinics/anc_treatment.vue";

// ===============================dental clinic===================================

import DentalVisits from "../views/special_clinics/dental/dental_list.vue";
import DentalTreatment from "../views/special_clinics/dental/dental_profile.vue";
import DentalInvestigations from "../views/special_clinics/dental/dental_investigations.vue";
import DentalDiagnosis from "../views/special_clinics/dental/dental_diagnosis.vue";
import DentalHistory from "../views/special_clinics/dental/dental_history.vue";
import DentalProcedures from "../views/special_clinics/dental/dental_procedures.vue";
import DentalImaging from "../views/special_clinics/dental/dental_imaging.vue";
import DentalPrescriptions from "../views/special_clinics/dental/dental_prescriptions.vue";
import DentalNotes from "../views/special_clinics/dental/dental_notes.vue";

// ================================end dental===========================================

// ===============================eye clinic===================================

import EyeVisits from "../views/special_clinics/eye/eye_list.vue";
import EyeTreatment from "../views/special_clinics/eye/eye_profile.vue";
import EyeInvestigations from "../views/special_clinics/eye/eye_investigations.vue";
import EyeDiagnosis from "../views/special_clinics/eye/eye_diagnosis.vue";
import EyeHistory from "../views/special_clinics/eye/eye_history.vue";
import EyeProcedures from "../views/special_clinics/eye/eye_procedures.vue";
import EyeImaging from "../views/special_clinics/eye/eye_imaging.vue";
import EyePrescriptions from "../views/special_clinics/eye/eye_prescriptions.vue";
import EyeNotes from "../views/special_clinics/eye/eye_notes.vue";

// ================================end eye===========================================

import AncProfile from "../views/special_clinics/mch/anc/anc_profile.vue";
import WeightMonitoring from "../views/special_clinics/mch/anc/anc_weight_monitoring.vue";
import PresentPregnancy from "../views/special_clinics/mch/anc/anc_present_pregnancy.vue";
import TetanusInjections from "../views/special_clinics/mch/anc/anc_tetanus_injections.vue";
import MedicalHistory from "../views/special_clinics/mch/anc/anc_medical_history.vue";
import Investigations from "../views/special_clinics/mch/anc/anc_investigations.vue";

import PncTreatment from "../views/special_clinics/pnc_treatment.vue";
import PncMaternalTreatment from "../views/special_clinics/pnc_maternal_tratment.vue";

import PncVisits from "../views/special_clinics/mch/pnc_visits.vue";
import MaternityVisits from "../views/special_clinics/mch/maternity.vue";
import MaternityTreatment from "../views/special_clinics/mch/maternity_treatment.vue";
import CwcVisits from "../views/special_clinics/mch/cwc.vue";
import FamilyPlanningVisits from "../views/special_clinics/mch/family_planning.vue";

import InpatientList from "../views/inpatient/inpatient_list.vue";

import CreateOrg from "../views/backoffice/create_org.vue";

import RolePermissions from "../views/system_users/role_permissions.vue";
import SystemRoles from "../views/system_users/system_roles.vue";

import ClinicalReports from "../views/clinical_reports/clinical_reports_index.vue";
import MOH204A from "../views/clinical_reports/moh204a.vue";
import MOH705A from "../views/clinical_reports/moh705a.vue";
import MOH301 from "../views/clinical_reports/moh301.vue";
import MOH711 from "../views/clinical_reports/moh711.vue";
import MOH510 from "../views/clinical_reports/moh510.vue";
import MOH710 from "../views/clinical_reports/moh710.vue";
import MOH405 from "../views/clinical_reports/moh405.vue";
import MOH333 from "../views/clinical_reports/moh333.vue";
import MOH406 from "../views/clinical_reports/moh406.vue";
import MOH711A from "../views/clinical_reports/moh711a.vue";
import MOH511 from "../views/clinical_reports/moh511.vue";
import MOH335 from "../views/clinical_reports/moh335.vue";
import MOH706 from "../views/clinical_reports/moh706.vue";
import MOH643 from "../views/clinical_reports/moh643.vue";
import MOH711f from "../views/clinical_reports/moh711f.vue";
import MOH732 from "../views/clinical_reports/moh732.vue";
import MOH505 from "../views/clinical_reports/moh505.vue";
import MOH717 from "../views/clinical_reports/moh717.vue";
import MOH516 from "../views/clinical_reports/moh516.vue";

const routes = [
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
    meta: { requiresAuth: false },
  },

  {
    path: "/",
    name: "/",
    redirect: "/visits_management", //"/dashboard",
    meta: { requiresAuth: true },
  },

  {
    path: "/consumable_specific/:serciceID",
    name: "Consumables Set",
    component: ConsumablesSet,
    meta: { requiresAuth: true },
  },

  {
    path: "/charge_consumable_specific/:serciceID",
    name: "Charge Consumables Set",
    component: ChargeConsumablesSet,
    meta: { requiresAuth: true },
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: { requiresAuth: true },
  },
  {
    path: "/special_clinics",
    name: "Special Clinics",
    component: SpecialClinicsMenu,
    meta: { requiresAuth: true },
  },

  {
    path: "/eye_clinic",
    name: "Eye",
    redirect: "/eye_clinic/eye_queue",
    children: [
      {
        path: "eye_queue",
        name: "Eye Clinic Queue",
        component: EyeVisits,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-treatment",
        name: "Eye Treatment",
        component: EyeTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-charting/:visit_id",
        name: "Eye Charting",
        component: EyeTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-procedures/:visit_id",
        name: "Eye Procedures",
        component: EyeProcedures,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-history/:visit_id",
        name: "Eye History",
        component: EyeHistory,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-diagnosis/:visit_id",
        name: "Eye Diagnosis",
        component: EyeDiagnosis,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-investigations/:visit_id",
        name: "Eye Investigations",
        component: EyeInvestigations,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-imaging/:visit_id",
        name: "Eye Imaging",
        component: EyeImaging,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-prescriptions/:visit_id",
        name: "Eye Prescriptions",
        component: EyePrescriptions,
        meta: { requiresAuth: true },
      },
      {
        path: "eye-notes/:visit_id",
        name: "Eye Notes",
        component: EyeNotes,
        meta: { requiresAuth: true },
      },
    ],
  },

  {
    path: "/dental_clinic",
    name: "Dental",
    redirect: "/dental_clinic/dental_queue",
    children: [
      {
        path: "dental_queue",
        name: "Dental Clinic Queue",
        component: DentalVisits,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-treatment",
        name: "Dental Treatment",
        component: DentalTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-charting/:visit_id",
        name: "Dental Charting",
        component: DentalTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-procedures/:visit_id",
        name: "Dental Procedures",
        component: DentalProcedures,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-history/:visit_id",
        name: "Dental History",
        component: DentalHistory,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-diagnosis/:visit_id",
        name: "Dental Diagnosis",
        component: DentalDiagnosis,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-investigations/:visit_id",
        name: "Dental Investigations",
        component: DentalInvestigations,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-imaging/:visit_id",
        name: "Dental Imaging",
        component: DentalImaging,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-prescriptions/:visit_id",
        name: "Dental Prescriptions",
        component: DentalPrescriptions,
        meta: { requiresAuth: true },
      },
      {
        path: "dental-notes/:visit_id",
        name: "Dental Notes",
        component: DentalNotes,
        meta: { requiresAuth: true },
      },
      // {
      //   path: "dental-medical-history",
      //   name: "Medical Histories",
      //   component: DentalTreatment,
      //   meta: { requiresAuth: true },
      // },
    ],
  },

  {
    path: "/mch",
    name: "MCH",
    redirect: "/mch/mch_index",
    children: [
      {
        path: "mch_index",
        name: "MCH Home",
        component: MchIndex,
        meta: { requiresAuth: true },
      },
      {
        path: "anc_list",
        name: "Anc Visits",
        component: AncVisits,
        meta: { requiresAuth: true },
      },
      {
        path: "anc_treatment/:visit_id",
        name: "ANC Treatment",
        component: AncTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "anc_treatment/anc-profile/:visit_id",
        name: "ANC profile",
        component: AncProfile,
        meta: { requiresAuth: true },
      },

      {
        path: "anc_treatment/weight-monitoring/:visit_id",
        name: "ANC Weight Monitoring",
        component: WeightMonitoring,
        meta: { requiresAuth: true },
      },
      {
        path: "anc_treatment/present-pregnancy/:visit_id",
        name: "ANC Present Pregnancy",
        component: PresentPregnancy,
        meta: { requiresAuth: true },
      },
      {
        path: "anc_treatment/investigations/:visit_id",
        name: "ANC Investigations and Lab Results",
        component: Investigations,
        meta: { requiresAuth: true },
      },
      {
        path: "anc_treatment/tetanus-injections/:visit_id",
        name: "ANC Preventive Services",
        component: TetanusInjections,
        meta: { requiresAuth: true },
      },

      {
        path: "anc_treatment/medical-history/:visit_id",
        name: "ANC Medical History",
        component: MedicalHistory,
        meta: { requiresAuth: true },
      },
      // ----------------anc----------------------
      {
        path: "pnc_list",
        name: "PNC Visits",
        component: PncVisits,
        meta: { requiresAuth: true },
      },
      {
        path: "pnc_treatment",
        name: "PNC Treatment",
        component: PncTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "pnc_treatment/maternal_accessment",
        name: "Pnc MaternalTreatment",
        component: PncMaternalTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "maternity",
        name: "Maternity",
        component: MaternityVisits,
        meta: { requiresAuth: true },
      },
      {
        path: "maternity_treatment/:visit_id",
        name: "Maternity Treatment",
        component: MaternityTreatment,
        meta: { requiresAuth: true },
      },
      {
        path: "cwc",
        name: "Child Welfare Clinic",
        component: CwcVisits,
        meta: { requiresAuth: true },
      },
      {
        path: "family_planning",
        name: "Family Planning",
        component: FamilyPlanningVisits,
        meta: { requiresAuth: true },
      },

      // {
      //   path: "maternity_list",
      //   name: "Maternity Visits",
      //   component: MaternityVisits,
      //   meta: { requiresAuth: true },
      // },
    ],
  },

  {
    path: "/visits",
    name: "Visit",
    // component: VisitsDashboard,
    redirect: "/visits_management",
    children: [
      {
        path: "/visits_management",
        name: "Visits Management",
        component: VisitsDashboard,
        meta: { requiresAuth: true },
      },
      {
        path: "/reception",
        name: "Visits",
        component: ReceptionList,
        meta: { requiresAuth: true },
      },
      {
        path: "/reception_appointments",
        name: "Appointments",
        component: ReceptionAppointments,
        meta: { requiresAuth: true },
      },
      {
        path: "/triage",
        name: "Triage",
        component: Triage,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation",
        name: "Consultation",
        component: Consultation,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation/service/:visitid",
        name: "ConsultationService",
        component: ConsultationService,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation_at_lab/:visitid",
        name: "ConsultationAtLab",
        component: ConsultationAtLab,
        meta: { requiresAuth: true },
      },

      {
        path: "/consultation_at_radiology/:visitid",
        name: "ConsultationAtRadiology",
        component: ConsultationAtRadiology,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation_at_nursing/:visitid",
        name: "ConsultationAtNursing",
        component: ConsultationAtNursing,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation_at_pharmacy/:visitid",
        name: "ConsultationAtPharmacy",
        component: ConsultationAtPharmacy,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation_at_inpatient/:visitid",
        name: "ConsultationAtInpatient",
        component: ConsultationAtInpatient,
        meta: { requiresAuth: true },
      },
      {
        path: "/consultation_at_diagnosis/:visitid",
        name: "ConsultationAtDiagnosis",
        component: ConsultationAtDiagnosis,
        meta: { requiresAuth: true },
      },

      {
        path: "/lab",
        name: "Laboratory",
        component: Lab,
        meta: { requiresAuth: true },
      },
      {
        path: "/lab-details/:labID",
        name: "LabDetails",
        component: LabDetails,
        meta: { requiresAuth: true },
      },

      {
        path: "/radiology",
        name: "Radiology",
        component: Radiology,
        meta: { requiresAuth: true },
      },
      {
        path: "/nursing_room",
        name: "Nursing Room",
        component: NursingRoom,
        meta: { requiresAuth: true },
      },
      {
        path: "/pharmacy",
        name: "Pharmacy",
        component: Pharmacy,
        meta: { requiresAuth: true },
      },
      {
        path: "/cashier",
        name: "Cashier",
        component: Cashier,
        meta: { requiresAuth: true },
      },
      {
        path: "/cashier_walkin",
        name: "Cashier Walkin Clients",
        component: CashierWalkin,
        meta: { requiresAuth: true },
      },

      {
        path: "/receipts",
        name: "Receipts",
        component: Receipts,
        meta: { requiresAuth: true },
      },
      {
        path: "/invoices",
        name: "Invoices",
        component: Invoices,
        meta: { requiresAuth: true },
      },
      {
        path: "/invoices/off-course",
        name: "Off-Course Invoices",
        component: OffCourseInvoices,
        meta: { requiresAuth: true },
      },
      {
        path: "/invoices/off-course/create",
        name: "Off-Course Invoice Create",
        component: OffCourseInvoiceCreate,
        meta: { requiresAuth: true },
      },
      {
        path: "/invoices/off-course/edit/:id",
        name: "Off-Course Invoice Edit",
        component: OffCourseInvoiceEdit,
        meta: { requiresAuth: true },
      },
      {
        path: "/invoices/off-course/view/:id",
        name: "Off-Course Invoice View",
        component: OffCourseInvoiceView,
        meta: { requiresAuth: true },
      },

      {
        path: "/invoices/invoiceDetail/:invoiceid",
        name: "Invoice Detail",
        component: InvoiceDetail,
        meta: { requiresAuth: true },
      },

      {
        path: "/invoices/insurance/invoiceDetail/:invoiceid",
        name: "Insurance Invoice Detail",
        component: InsuranceInvoiceDetail,
        meta: { requiresAuth: true },
      },

      {
        path: "/visits/ended",
        name: "Ended Visits",
        component: OTCPharmacy,
        meta: { requiresAuth: true },
      },
      {
        path: "/dialysis_queue",
        name: "Dialysis Patients",
        component: DialysisQueue,
        meta: { requiresAuth: true },
      },

      {
        path: "/dialysis_procedure/:visitid",
        name: "Dialysis Procedure",
        component: DialysisProcedure,
        meta: { requiresAuth: true },
      },

      {
        path: "/visit_summary/:visitid",
        name: "Visit Summary",
        component: VisitSummary,
        meta: { requiresAuth: true },
      },
    ],
  },

  // visit/reception
  // visit/triage
  // visit/consultation
  // visit/lab
  // visit/radiology
  // visit/nursing_room
  // visit/pharmacy
  // visit/cashier
  // visit/receipts
  // visit/invoices

  {
    path: "/inventory",
    name: "Inventory",
    //component: Inventory,
    redirect: "/inventory_dashboard",
    children: [
      {
        path: "/inventory_dashboard",
        name: "Inventory Dashboard",
        component: Inventory,
        meta: { requiresAuth: true },
      },
      {
        path: "/purchase_orders",
        name: "Purchase Orders",
        component: PurchaseOrdersIndex,
        meta: { requiresAuth: true },
      },
      {
        path: "/create_new_purchase_order",
        name: "Create Purchase Orders",
        component: PurchaseOrdersCreate,
        meta: { requiresAuth: true },
      },

      {
        path: "/purchase_order/detail/:orderID",
        name: "Purchase Orders Detail",
        component: PurchaseOrdersDetail,
        meta: { requiresAuth: true },
      },

      {
        path: "/purchase_order_delivered/detail/:orderID",
        name: "Purchase Orders Delivered Detail",
        component: PurchaseOrdersDeliveredDetail,
        meta: { requiresAuth: true },
      },

      {
        path: "/item_categories",
        name: "Item Categories",
        component: ItemCategories,
        meta: { requiresAuth: true },
      },
      {
        path: "/item_classes",
        name: "Item Classes",
        component: ItemClasses,
        meta: { requiresAuth: true },
      },
      {
        path: "/item_stores",
        name: "Item Stores",
        component: ItemStores,
        meta: { requiresAuth: true },
      },
      {
        path: "/item_suppliers",
        name: "Item Suppliers",
        component: ItemSuppliers,
        meta: { requiresAuth: true },
      },
      {
        path: "/item_register",
        name: "Item Register",
        component: ItemRegister,
        meta: { requiresAuth: true },
      },
      {
        path: "/item_stock/:storeLocation",
        name: "Item Stock",
        component: ItemStock,
        meta: { requiresAuth: true },
      },
      {
        path: "/out_of_stock/:storeLocation",
        name: "Out Of Stock",
        component: OutOfStock,
        meta: { requiresAuth: true },
      },
      {
        path: "/expiring",
        name: "Expiring Items",
        component: Expiring,
        meta: { requiresAuth: true },
      },

      {
        path: "/item_stock_details/:storeLocation",
        name: "Stock Details",
        component: ItemStockDetails,
        meta: { requiresAuth: true },
      },
      {
        path: "/stock_taking_session/:sessionId/:storeLocation",
        name: "Stock Take Session",
        component: StockTakingSession,
        meta: { requiresAuth: true },
      },
      {
        path: "/stock_taking_session_report/:sessionId/:storeLocation",
        name: "Stock Take Report",
        component: StockTakingReport,
        meta: { requiresAuth: true },
      },
      {
        path: "/stock_taking/:storeLocation",
        name: "Stock Edits",
        component: StockTakingIndex,
        meta: { requiresAuth: true },
      },
      {
        path: "/internal_orders/:storeLocation",
        name: "Internal Orders",
        component: InternalOrders,
        meta: { requiresAuth: true },
      },
    ],
  },

  // {
  //   path: "/settings",
  //   name: "Settings",
  //   component: Settings,
  // },

  {
    path: "/setting",
    name: "Settings",
    redirect: "/setting/settings",
    children: [
      {
        path: "settings",
        name: "SettingsHome",
        component: Settings,
        meta: { requiresAuth: true },
      },
      {
        path: "dialysis",
        name: "Dialysis Settings",
        component: DialysisSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "insurance_settings",
        name: "Insurance Settings",
        component: InsuranceSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "scheme_settings/:company",
        name: "Scheme Settings",
        component: SchemeSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "additional_settings",
        name: "Additional Settings",
        component: AdditionalSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "services/lab",
        name: "LabSettings",
        component: LabSetting,
        meta: { requiresAuth: true },
      },
      {
        path: "services/radiology",
        name: "RadiologySettings",
        component: RadiologySetting,
        meta: { requiresAuth: true },
      },
      {
        path: "services/nursing",
        name: "NursingSettings",
        component: NursingSetting,
        meta: { requiresAuth: true },
      },
      {
        path: "services/inpatient",
        name: "Inpatient Settings",
        component: InpatientSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "services/other",
        name: "Other Settings",
        component: OtherSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "org_info",
        name: "Organization Info",
        component: OrgSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "messaging_settings",
        name: "Messaging Settings",
        component: MessagingSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "bed_setting",
        name: "Bed Settings",
        component: BedSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "bed_classes",
        name: "Bed Classes",
        component: BedClass,
        meta: { requiresAuth: true },
      },

      {
        path: "ward_setting",
        name: "Ward Settings",
        component: WardSettings,
        meta: { requiresAuth: true },
      },
      {
        path: "backoffice_create_organization",
        name: "Create Organization",
        component: CreateOrg,
        meta: { requiresAuth: true },
      },
      {
        path: ":catchAll(.*)",
        redirect: "/setting/settings",
      },
    ],
  },

  {
    path: "/inpatient",
    name: "Inpatient",
    redirect: "/inpatient/inpatient_index",
    children: [
      {
        path: "inpatient_index",
        name: "InpatientHome",
        component: InpatientIndex,
        meta: { requiresAuth: true },
      },
      {
        path: "awaiting_bed_assignment",
        name: "Awaiting Beds",
        component: AwaitingBeds,
        meta: { requiresAuth: true },
      },
      {
        path: "inpatient_list",
        name: "Inpatient List",
        component: InpatientList,
        meta: { requiresAuth: true },
      },
      {
        path: "inpatient_timeline/:visitID",
        name: "Inpatient Timeline",
        component: InpatientTimeline, //Profile,
        meta: { requiresAuth: true },
      },
    ],
  },

  {
    path: "/finance",
    name: "Finance",
    redirect: "/finance/finance_index",
    children: [
      {
        path: "finance_index",
        name: "Finance Dashboard",
        component: FinanceIndex,
        meta: { requiresAuth: true },
      },
      {
        path: "revenue_by_dates",
        name: "Revenue By Dates",
        component: RevenueByDates,
        meta: { requiresAuth: true },
      },
      {
        path: "pending_invoices",
        name: "Pending Invoices",
        component: PendingInvoices,
        meta: { requiresAuth: true },
      },
      {
        path: "insurance_claims_overview",
        name: "Insurance Claims Overview",
        component: InsuranceClaims,
        meta: { requiresAuth: true },
      },
      {
        path: "expenses_overview",
        name: "Expenses Overview",
        component: Expenses,
        meta: { requiresAuth: true },
      },

      {
        path: "inventory_and_sales",
        name: "Inventory & Sales",
        component: InventoryAndSales,
        meta: { requiresAuth: true },
      },
      {
        path: "accounts",
        name: "Accounts",
        component: Accounts,
        meta: { requiresAuth: true },
      },

      {
        path: "finance_account_detail/:accountID",
        name: "Account Detail",
        component: FinanceAccountDetail,
        meta: { requiresAuth: true },
      },
      //
      {
        path: "expense_account_detail/:accountID",
        name: "Expense Account Detail",
        component: ExpenseAccountDetail,
        meta: { requiresAuth: true },
      },
      {
        path: "inventory_account_detail/:accountID",
        name: "Inventory Account Detail",
        component: InventoryAccountDetail,
        meta: { requiresAuth: true },
      },
      {
        path: "payable_account_detail/:accountID",
        name: "Payable Account Detail",
        component: PayableAccountDetail,
        meta: { requiresAuth: true },
      },
      //
      {
        path: "account_statement/:accountID",
        name: "Account Statement",
        component: AccountStatement,
        meta: { requiresAuth: true },
      },
      {
        path: "po_processing",
        name: "P.O Processing",
        component: POProcessing,
        meta: { requiresAuth: true },
      },
      {
        path: "finance_book",
        name: "Finance Book",
        component: FinanceBook,
        meta: { requiresAuth: true },
      },

      {
        path: "invoice_breakdown/:invoiceType",
        name: "Invoice Breakdown",
        component: InvoiceBreakdown,
        meta: { requiresAuth: true },
      },
    ],
  },

  // {
  //   path: "/finance",
  //   name: "Finance",
  //   component: FinanceIndex,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/clinical_reports",
    name: "Clinical Reports",
    component: ClinicalReports,
    meta: { requiresAuth: true },
  },

  {
    path: "/reports",
    name: "MOH Reports",
    redirect: "/clinical_reports",
    children: [
      {
        path: "moh-204a",
        name: "MOH 204A",
        component: MOH204A,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-705",
        name: "MOH 705A",
        component: MOH705A,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-301",
        name: "MOH 301",
        component: MOH301,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-711",
        name: "MOH 711",
        component: MOH711,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-510",
        name: "MOH 510",
        component: MOH510,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-710",
        name: "MOH 710",
        component: MOH710,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-405",
        name: "MOH 405",
        component: MOH405,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-333",
        name: "MOH 333",
        component: MOH333,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-406",
        name: "MOH 406",
        component: MOH406,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-711a",
        name: "MOH 711A",
        component: MOH711A,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-511",
        name: "MOH 511",
        component: MOH511,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-335",
        name: "MOH 335",
        component: MOH335,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-706",
        name: "MOH 706",
        component: MOH706,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-643",
        name: "MOH 643",
        component: MOH643,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-711-commodity",
        name: "MOH 711",
        component: MOH711f,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-732",
        name: "MOH 732",
        component: MOH732,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-505",
        name: "MOH 505",
        component: MOH505,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-717",
        name: "MOH 717",
        component: MOH717,
        meta: { requiresAuth: true },
      },
      {
        path: "moh-516",
        name: "MOH 516",
        component: MOH516,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/hr",
    name: "HR",
    component: Tables,
    meta: { requiresAuth: true },
  },
  {
    path: "/system_users",
    name: "System Users",
    component: SystemUsers,
    meta: { requiresAuth: true },
  },
  {
    path: "/system_roles",
    name: "System Roles",
    component: SystemRoles,
    meta: { requiresAuth: true },
  },
  {
    path: "/role_permissions/:roleID",
    name: "Role Permissions",
    component: RolePermissions,
    meta: { requiresAuth: true },
  },

  {
    path: "/patients",
    name: "Patients",
    component: PatientsIndex,
    meta: { requiresAuth: true },
  },

  {
    path: "/dialysis",
    name: "Dialysis",
    component: Dialysis,
    meta: { requiresAuth: true },
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true },
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
    meta: { requiresAuth: true },
  },

  {
    path: "/communications",
    name: "Communications",
    component: Communications,
    meta: { requiresAuth: true },
  },
  {
    path: "/communication_logs",
    name: "CommunicationLogs",
    component: CommunicationLogs,
    meta: { requiresAuth: true },
  },
  {
    path: "/sms_credits",
    name: "SMS Credit",
    component: SmsCredit,
    meta: { requiresAuth: true },
  },

  // CATCH ALL ROUTE — should be last
  {
    path: "/:catchAll(.*)",
    redirect: "/visits_management",
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  // routes,
  // linkActiveClass: "active",
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
// console.log("this is in an execiting block");
// Navigation Guard for Authentication Check
router.beforeEach((to, from, next) => {
  // const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  // console.log("➡️ Route requires authentication?", requiresAuth);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // const isAuthenticated = this.$store.getters.isAuthenticated;
    const isAuthenticated = store.getters.isAuthenticated; // Use store directly
    // console.log("➡️ Route is authenticated?", isAuthenticated);
    if (isAuthenticated) {
      next();
      // next("/sign-in");
    } else {
      // console.log("executing here");
      next("/sign-in"); // Redirect to login if not authenticated
      // window.location.replace("/sign-in");
    }
  } else {
    // console.log("this is in an execiting block");
    next(); // Allow access to public routes
  }
});

export default router;
